<script>
import config from '../assets/config.json'
import EventBus from '../bus'

export const websocketEventName = 'wsMessage'

export default {
  data: () => ({
    websocketConnection: {},
    websocketInitialized: false,
    websocketIsConnected: false,
    websocketTimerId: 0
  }),
  created: function () {
    this.wsConnect()
  },
  beforeDestroy () {
    window.clearInterval(this.websocketTimerId)
  },
  methods: {
    wsChangeApp (app) {
      this.websocketConnection.send(JSON.stringify({ app }))
    },
    wsConnect () {
      this.wsInit()
      const self = this
      console.log('try init ws')
      this.websocketTimerId = window.setInterval(() => {
        if (!self.websocketIsConnected) {
          self.wsInit()
        }
      }, config.websocket.reconnectTimeInterval)
    },
    wsInit () {
      const wssUrl = config.websocket.connections.prod
      this.websocketConnection = new WebSocket(wssUrl)

      const self = this
      this.websocketConnection.onopen = () => {
        console.log('con open')
        self.websocketIsConnected = true
        window.clearInterval(self.websocketTimerId)
        self.websocketConnection.send(
          JSON.stringify({
            app: self.currentApplication,
            currentUser: self.currentUser,
            initialize: true
          })
        )
      }

      this.websocketConnection.onclose = () => {
        console.log('ws close')
        if (self.websocketIsConnected) {
          self.websocketIsConnected = false
          self.wsConnect()
        } else {
          self.websocketIsConnected = false
        }
      }

      /**
       * deprecated: The EventBus pattern is deprecated! Please use simple Vue child-parent-pattern: $emit!
       */
      this.websocketConnection.onmessage = message => EventBus.$emit(websocketEventName, JSON.parse(message.data))
      this.websocketInitialized = true
    },
    wsSend (data) {
      this.websocketConnection.send(JSON.stringify(data))
    }
  }
}
</script>




// WEBPACK FOOTER //
// src/mixins/Websocket.vue